import React from "react";
import "../css/about.scss";

function About() {
  return (
    <div className="about">
      <div className="about-top">
        <div className="about-image">
          <img src="/main/ovh-about.png" alt="The Ovahorizon design studio" />
        </div>
        <div className="about-text">
          <h2>ABOUT US</h2>
          <p>
            Ovahorizon is an independent, design-led fashion brand made by
            people for people. We
            are known for bold ideas, attention to detail, and effortless style.
          </p>
          <p>
            We create modern, feminine looks that are both high-quality and
            affordable, proving that great design doesn't have to be expensive.
          </p>
          <p>
            Creative, curious, and self-assured, Ovahorizon is made for women who
            express themselves freely and who speak up about the topics that
            matter.
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;
